"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _svgElements = require("../../components/svg-elements");

var _hotspot = require("../../hotspot.defaultConfigs");

var _Plus = require("./Plus.styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Plus = function Plus(_ref) {
  var config = _ref.config,
      iconPosition = _ref.iconPosition,
      onClick = _ref.onClick,
      previewHoverState = _ref.previewHoverState,
      disableHover = _ref.disableHover,
      name = _ref.name;
  var plusConfig = config || _hotspot.plus;
  var primaryColor = plusConfig.primaryColor,
      secondaryColor = plusConfig.secondaryColor;
  var ariaLabel = "".concat(name, " hotspot");
  return _react.default.createElement(_Plus.ClickableAreaStyled, {
    onClick: onClick,
    previewHoverState: previewHoverState,
    disableHover: disableHover,
    "aria-label": ariaLabel
  }, iconPosition && _react.default.createElement(_Plus.PlusStyled, {
    config: plusConfig,
    iconPosition: iconPosition,
    previewHoverState: previewHoverState
  }, _react.default.createElement(_svgElements.Svg, {
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMinYMin",
    height: "100%",
    width: "100%"
  }, _react.default.createElement(_Plus.CirclePathStyled, {
    strokeWidth: "1",
    fill: secondaryColor,
    stroke: "none",
    strokeOpacity: "1",
    d: "M50,1.5C23.2,1.5,1.5,23.2,1.5,50S23.2,98.5,50,98.5C76.8,98.5,98.5,76.7,98.5,50S76.8,1.5,50,1.5ZM50,85.7C30.3,85.7,14.299999999999997,69.7,14.299999999999997,50C14.299999999999997,30.3,30.299999999999997,14.299999999999997,50,14.299999999999997S85.7,30.299999999999997,85.7,50C85.7,69.7,69.7,85.7,50,85.7Z",
    strokeLinecap: "round"
  }), _react.default.createElement(_svgElements.Path, {
    strokeWidth: "1",
    fill: primaryColor,
    stroke: "none",
    strokeOpacity: "1",
    d: "M70.6,46.3H53.7V29.4c0-0.6-0.5-1.2-1.2-1.2h-5.1c-0.6,0-1.2,0.5-1.2,1.2v16.9H29.4 c-0.6,0-1.2,0.5-1.2,1.2v5.1c0,0.6,0.5,1.2,1.2,1.2h16.9v16.9c0,0.6,0.5,1.2,1.2,1.2h5.1c0.6,0,1.2-0.5,1.2-1.2V53.7h16.9 c0.6,0,1.2-0.5,1.2-1.2v-5.1C71.8,46.8,71.3,46.3,70.6,46.3z",
    strokeLinecap: "round"
  }))));
};

var _default = Plus;
exports.default = _default;